// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.completed {
  background-color: #157347;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 24px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 600;
}

.rejected {
  background-color: #dc3545;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 24px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 600;
}

.cancelled {
  background-color: #ffc107;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 24px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 600;
}

.pastOrdersCardTypeBox {
  display: inline-flex;
  text-align: center;
  font-weight: 600;
  border-radius: 5px;
  padding: 0px 10px;
  font-size: 10px;
  line-height: 23px;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/pages/yacht/home/nested/pastBerths/PastBerths.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":[".completed {\n  background-color: #157347;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 10px;\n  line-height: 24px;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 600;\n}\n\n.rejected {\n  background-color: #dc3545;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 10px;\n  line-height: 24px;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 600;\n}\n\n.cancelled {\n  background-color: #ffc107;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 10px;\n  line-height: 24px;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 600;\n}\n\n.pastOrdersCardTypeBox {\n  display: inline-flex;\n  text-align: center;\n  font-weight: 600;\n  border-radius: 5px;\n  padding: 0px 10px;\n  font-size: 10px;\n  line-height: 23px;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
